export default {
  videos: [],
  marketSegments: [],
  incompleteVideosCount: 0
}



// WEBPACK FOOTER //
// ./src/store/modules/video/state.js